import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
import * as _ from "lodash";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "PickLocation",
  data: () => ({
    locationItems: [],
    searchLocation: "",
    selectedLocation: {},
    isLoadingLocations: false,
    principalCache: new Map(),
    hasFocus: false
  }),
  props: {
    label: {
      type: String,
      default: null
    },
    locationId: {
      type: String,
      default: null
    },
    principalObjects: {
      type: Array,
      default: null
    }
  },
  async mounted() {
    this.debounceLocationSearch = _.debounce(this.searchLocationFunc, 200);
    await this.searchLocationFunc({ id: this.locationId });
    this.addListeners();
  },
  computed: {
    locationPlaceholder() {
      return this.locationId === this.selectedLocation?._id && !this.hasFocus
        ? this.selectedLocation.label
        : "Standort tippen...";
    }
  },
  methods: {
    addListeners() {
      // update has focus field
      let autocompleteInput = this.$refs.autocomplete.$refs.input;
      autocompleteInput.addEventListener(
        "focus",
        () => (this.hasFocus = true),
        true
      );
      autocompleteInput.addEventListener(
        "blur",
        () => (this.hasFocus = false),
        true
      );
    },
    async searchLocationFunc({ val, id }) {
      this.isLoadingLocations = true;
      if (!this.principalObjects?.length) {
        console.info("need principalObjects to perform location-search");
        this.isLoadingLocations = false;
        return;
      }
      const headers = getTokenHeader();
      let params = {
        principal_id: this.principalObjects.map(p => p._id),
        type: "location"
      };
      if (val) params.s = val;
      try {
        const response = await axios.get(
          env.events_api_client_url + "oploc/" + (id || ""),
          {
            params,
            headers
          }
        );
        const getLocationWithPrincipalLabel = data => {
          return {
            ...data,
            label:
              data.title + ` (${this.findSubPrincipalTitle(data.principal_id)})`
          };
        };
        if (id) {
          const data = response?.data;
          this.selectedLocation = getLocationWithPrincipalLabel(data);
          this.isLoadingLocations = false;
          return;
        }
        this.locationItems = response?.data.map(d => {
          return getLocationWithPrincipalLabel(d);
        });
      } catch (error) {
        console.error(error);
      }
      this.isLoadingLocations = false;
    },
    findSubPrincipalTitle(id) {
      const subP =
        this.principalCache.get(id) ||
        this.principalObjects.find(p => id === p._id);
      if (!subP) return "unknown-principal";
      this.principalCache.set(id, subP);
      return subP.name;
    }
  },
  watch: {
    async searchLocation(val) {
      if (val === this.selectedLocation?.label) return;
      if (this.debounceLocationSearch) this.debounceLocationSearch({ val });
    }
  }
};
